import { AppModule } from 'app/module';
import { user } from 'app/user';
import { patchJson } from 'util/xhr';
import './styles.scss';
import Template from './template.hbs';

export class JobsInfoBox extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            inner: '.m-jobsInfoBox__inner',
            box: '.m-jobsInfoBox__box',
            text: '.m-jobsInfoBox__text',
            list: '.m-jobsInfoBox__list',
            listItems: ['.m-jobsInfoBox__listItem'],
            link: '.m-jobsInfoBox__link',
            actionLink: '.m-jobsInfoBox__link--action',
            modalLinks: ['.m-jobsInfoBox__modalLink'],
            preAdditionalLinkText: '.m-jobsInfoBox__preAdditionalLinkText',
            postAdditionalLinkText: '.m-jobsInfoBox__postAdditionalLinkText',
            closeButton: '.m-jobsInfoBox__closeButton',
        };
    }

    domEvents() {
        if (this.dom.actionLink) {
            this.dom.actionLink.addEventListener('click', (e) => {
                if (e) e.preventDefault();

                if (this.props.link.request) {
                    if (this.request) {
                        this.request.abort();
                    }

                    if (!this.props.link.passWithHash && !user.isLoggedIn()) {
                        this.events.emit('passWithHash');
                    } else {
                        this.request = patchJson(
                            this.dom.actionLink.href,
                            {},
                            (response) => this.onActionLinkResponse(response),
                        );
                    }
                } else {
                    this.events.emit('infoBoxActionLinkClicked');
                }
            });
        }
        for (let i = 0; i < this.dom.modalLinks.length; i += 1) {
            this.dom.modalLinks[i].addEventListener('click', (e) => {
                if (e) e.preventDefault();
                this.events.emit(
                    'openEditModal',
                    this.dom.modalLinks[i].href,
                    this.dom.modalLinks[i].innerText,
                    this.dom.modalLinks[i].getAttribute('data-type'),
                );
            });
        }
        if (this.dom.closeButton) {
            this.dom.closeButton.addEventListener('click', () => {
                this.events.emit('closeInfoBox');
                this.updateProps({ active: false }, true);
            });
        }
    }

    onActionLinkResponse() {
        window.location.reload(true);
    }

    getPropsFromDom() {
        const listItems = [];
        for (let i = 0; i < this.dom.listItems.length; i += 1) {
            listItems.push(this.dom.listItems[i].innerHTML);
        }
        return {
            active: !!this.dom.inner,
            text: this.dom.text ? this.dom.text.innerHTML : '',
            concernsListing: this.dom.inner ? this.dom.inner.getAttribute('data-concerns-listing') : false,
            warning: this.dom.box ? this.dom.box.classList.contains('m-jobsInfoBox__box--warning') : false,
            hint: this.dom.box ? this.dom.box.classList.contains('m-jobsInfoBox__box--hint') : false,
            closeable: !!this.dom.closeButton,
            containsList: !!this.dom.list,
            listItems,
            link: {
                active: !!this.dom.link,
                url: this.dom.link ? this.dom.link.href : '',
                method: this.dom.link ? this.dom.link.getAttribute('data-method') : '',
                actionLink: this.dom.link ? this.dom.link.classList.contains('m-jobsInfoBox__link--action') : false,
                request: this.dom.link ? (this.dom.link.getAttribute('data-request') === 'true') : false,
                label: this.dom.link ? this.dom.link.innerText : '',
                preAdditionalLinkText: this.dom.preAdditionalLinkText ? this.dom.preAdditionalLinkText.innerText : '',
                postAdditionalLinkText: this.dom.postAdditionalLinkText
                    ? this.dom.postAdditionalLinkText.innerText : '',
                passWithHash: this.dom.actionLink ? this.dom.actionLink.getAttribute('data-pass-with-hash') : false,
            },
        };
    }
}
